/* global BigInt */
const currencyFormat = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
});

const currencyFormat2 = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
});

export const getSymbolCode = () => {
    let baseCurrency = sessionStorage.getItem("base_currency");
    if (baseCurrency) {
        baseCurrency = JSON.parse(baseCurrency);

    }
    return baseCurrency?.symbol_code;
}


export const getSymbol = () => {
    let baseCurrency = sessionStorage.getItem("base_currency");
    if (baseCurrency) {
        baseCurrency = JSON.parse(baseCurrency);
    }
    return baseCurrency?.iso_code;
}

export const millify = (amount, isK, isZ) => {
    let num = parseFloat(amount);
    if (!Number.isFinite(num)) {
        return "-";
    }
    let absAmount = Math.abs(num);

    if (absAmount >= 1.0e19) {
        try {
            // Truncate extremely large numbers
            // Use string representation to avoid integer precision loss for powers of 10
            let strAmount = num.toString();
            let bigIntVal;
            if (strAmount.includes('e')) {
                const parts = strAmount.split('e');
                const mantissa = parseFloat(parts[0]);
                const exponent = parseInt(parts[1]);
                bigIntVal = BigInt(Math.round(mantissa * Math.pow(10, Math.max(0, exponent > 20 ? 20 : exponent)))) * BigInt(10n ** BigInt(Math.max(0, exponent - (exponent > 20 ? 20 : exponent))));

                let [m, e] = strAmount.split('e');
                e = parseInt(e);
                m = m.replace('.', '');
                const decimalPlaces = (parts[0].split('.')[1] || []).length;
                const power = e - decimalPlaces;
                if (power >= 0) {
                    bigIntVal = BigInt(m) * (10n ** BigInt(power));
                } else {
                    bigIntVal = BigInt(m) / (10n ** BigInt(-power));
                }
            } else {
                bigIntVal = BigInt(Math.trunc(num));
            }

            let strStr = bigIntVal.toLocaleString("en-US");
            if (strStr.length > 12) {
                return strStr.substring(0, 12).replace(/[^0-9]$/, "") + "...";
            }
            return strStr;
        } catch (e) {
            console.error("Millify error", e);
            // Fallback to simple BigInt if logic fails, or exponential
            try {
                return BigInt(Math.trunc(num)).toLocaleString("en-US").substring(0, 12) + "...";
            } catch (err) {
                return num.toExponential(2);
            }
        }
    } else if (absAmount >= 1.0e12) {
        return currencyFormat.format(num / 1.0e12) + "T";
    } else if (absAmount >= 1.0e9) {
        return currencyFormat.format(num / 1.0e9) + "B";
    } else if (absAmount >= 1.0e5) {
        // Starts at 100,000 -> 0.10M to match previous behavior (length >= 6)
        return currencyFormat.format(num / 1.0e6) + "M";
    } else if (absAmount >= 1.0e3 && isK) {
        return currencyFormat.format(num / 1.0e3) + "K";
    }
    return currencyFormat.format(num);
};

export const graph_millify = (amount, isK, isZ) => {
    let num = parseFloat(amount);
    if (!Number.isFinite(num)) {
        return "-";
    }
    let absAmount = Math.abs(num);

    if (absAmount >= 1.0e19) {
        try {
            let strAmount = num.toString();
            let bigIntVal;
            if (strAmount.includes('e')) {
                const parts = strAmount.split('e');
                // Robust scientific notation parsing
                let [m, e] = strAmount.split('e');
                e = parseInt(e);
                m = m.replace('.', '');
                const decimalPlaces = (parts[0].split('.')[1] || []).length;
                const power = e - decimalPlaces;
                if (power >= 0) {
                    bigIntVal = BigInt(m) * (10n ** BigInt(power));
                } else {
                    bigIntVal = BigInt(m) / (10n ** BigInt(-power));
                }
            } else {
                bigIntVal = BigInt(Math.trunc(num));
            }
            let strStr = bigIntVal.toLocaleString("en-US");
            if (strStr.length > 12) {
                return strStr.substring(0, 12).replace(/[^0-9]$/, "") + "...";
            }
            return strStr;
        } catch (e) {
            try {
                return BigInt(Math.trunc(num)).toLocaleString("en-US").substring(0, 12) + "...";
            } catch (err) {
                return num.toExponential(2);
            }
        }
    } else if (absAmount >= 1.0e12) {
        return currencyFormat2.format(num / 1.0e12) + "T";
    } else if (absAmount >= 1.0e9) {
        return currencyFormat2.format(num / 1.0e9) + "B";
    } else if (absAmount >= 1.0e5) {
        return currencyFormat2.format(num / 1.0e6) + "M";
    } else if (absAmount >= 1.0e3 && isK) {
        return currencyFormat2.format(num / 1.0e3) + "K";
    }
    return currencyFormat2.format(num);
};
